import React from 'react'
import Header from './../Common/Header'
import Footer from './../Common/Footer'
import Banner from './../Elements/Banner'
import AboutCompany from '../Elements/AboutCompany'
import Specialization3 from '../Elements/Specialization3'
import OurValue3 from '../Elements/OurValue3'
import OurProject3 from '../Elements/OurProject3'
import Faq from '../Elements/Faq'
import AboutCompany2 from '../Elements/AboutCompany2'
import Specialization6 from './Specialization6'
import OurValue6 from './OurValue6'
import OurProject6 from './OurProject6'
import Faq2 from './Faq2'

var bnrimg = require('./../../images/banner/1.jpg')

class IndoorAirQuality extends React.Component {
  render () {
    return (
      <>
        <Header />
        <div className='page-content'>
          <Banner
            title='Diversified services. Unvarying quality.'
            pagename='Services'
            bgimage={bnrimg}
          />
          <AboutCompany2 />
          <Specialization6 />
          <OurValue6/>
          <OurProject6 />
          {/* <Faq2 /> */}
          <Footer />
        </div>
      </>
    )
  }
}

export default IndoorAirQuality
